"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Types_1 = require("Types");
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("../../UI/Typography"));
const useHeaderData_1 = __importDefault(require("../../../Hooks/useHeaderData"));
const Hooks_1 = require("@/Hooks");
const react_helmet_1 = require("react-helmet");
const NOT_FOUND_PAGE_TITLE = '404 - Haldex';
const ErrorPage = ({ pageData, title, body, links, loginButton, isNotFoundPage, openLoginWindow }) => {
    const { t } = (0, Hooks_1.useTranslate)();
    const headerData = (0, useHeaderData_1.default)();
    if (!pageData)
        return null;
    return (react_1.default.createElement(styled.ContentAreaContainer, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null, NOT_FOUND_PAGE_TITLE)),
        isNotFoundPage && (react_1.default.createElement(styled.Row, null,
            react_1.default.createElement(styled.Col, null,
                !headerData && (pageData === null || pageData === void 0 ? void 0 : pageData.logo) && (react_1.default.createElement(styled.LogoContainer, null,
                    react_1.default.createElement(styled.ErrorPageLogo, { src: pageData === null || pageData === void 0 ? void 0 : pageData.logo, alt: 'logo' }))),
                (pageData === null || pageData === void 0 ? void 0 : pageData.imageHref) && react_1.default.createElement(styled.ErrorPageImage, { src: pageData.imageHref, alt: 'image-error' })))),
        react_1.default.createElement(styled_bootstrap_grid_1.Row, null,
            react_1.default.createElement(styled.Col, null,
                title && react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.H1 }, pageData.title),
                body && (react_1.default.createElement(styled.Description, { type: Typography_1.Types.INTRODUCTORY_TEXT, dangerouslySetInnerHTML: { __html: pageData.body.toString() } })),
                loginButton ? (react_1.default.createElement(styled.HomeButton, { onClick: () => openLoginWindow && openLoginWindow() }, t('/haldex/login_modal/login_button'))) : (links === null || links === void 0 ? void 0 : links.length) ? (react_1.default.createElement(styled.LinksWrapper, null, links.map(link => (link === null || link === void 0 ? void 0 : link.text) && (react_1.default.createElement("a", { href: (link === null || link === void 0 ? void 0 : link.href) || (headerData === null || headerData === void 0 ? void 0 : headerData.LogoUrl), target: (link === null || link === void 0 ? void 0 : link.target) || Types_1.Target.SELF, "data-force-reload": "true" },
                    react_1.default.createElement(styled.HomeButton, null, link === null || link === void 0 ? void 0 : link.text)))))) : null))));
};
exports.default = ErrorPage;
